import axiosInstance from "../../axiosInstance";
import type { 
  RequestAuthRequest, 
  RequestAuthResponse, 
  VerifyAuthRequest, 
  VerifyAuthResponse, 
  LogoutResponse,
  SocialProvider, 
  SocialLoginResponse,
  SocialCallbackResponse 
} from "./types";

export const authService = {
  requestAuth: async (data: RequestAuthRequest): Promise<RequestAuthResponse> => {
    const response = await axiosInstance.post<RequestAuthResponse>(
      "/user/auth/request-auth",
      data
    );
    return response.data;
  },

  verifyAuth: async (data: VerifyAuthRequest): Promise<VerifyAuthResponse> => {
    const response = await axiosInstance.post<VerifyAuthResponse>(
      "/user/auth/verify",
      data
    );
    return response.data;
  },

  logout: async (): Promise<LogoutResponse> => {
    console.log('[AuthService] POST /user/auth/logout');
    const response = await axiosInstance.post<LogoutResponse>(
      "/user/auth/logout"
    );
    console.log('[AuthService] Logout response:', response.data);
    return response.data;
  },

  socialLogin: async (provider: SocialProvider, redirectUrl?: string): Promise<SocialLoginResponse> => {
    const params = redirectUrl ? { redirectUrl } : undefined;
    const response = await axiosInstance.get<SocialLoginResponse>(
      `/user/auth/social/${provider}`,
      { params }
    );
    return response.data;
  },

  socialCallback: async (provider: SocialProvider, code: string, state: string): Promise<SocialCallbackResponse> => {
    const response = await axiosInstance.post<SocialCallbackResponse>(
      `/user/auth/social/${provider}/callback`,
      { code, state }
    );
    return response.data;
  },
};
